import { render, staticRenderFns } from "./Add-Alumni.vue?vue&type=template&id=ae027776&scoped=true"
import script from "./Add-Alumni.vue?vue&type=script&lang=js"
export * from "./Add-Alumni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae027776",
  null
  
)

export default component.exports